export const locale = {
    lang: 'en',
    data: {
        'LOGIN': {
            'TITLE': 'LOGIN TO YOUR ACCOUNT',
            'USERNAME': 'Email or username',
            'PASSWORD': 'Password',

            'VALIDATION': {
                'USERNAME': 'Username or email address is required',
                'USERNAME_INVALID': 'Please enter a valid email address or username',
                'PASSWORD': 'Password is required'
            },

            'ACTION': {
                'LOGIN_PASSWORD': 'Login',
                'LOGIN_GOOGLE': 'Log in with Google',
                'REMEMBER_ME': 'Remember Me',
                'FORGOT_PASSWORD': 'Forgot Password?'
            },

            'OTHER': {
                'LOGIN_ERROR': 'Error. Can\'t login. Username or Password is incorrect.',
                'SEPERATOR': 'OR'
            }
        },
        'DIALOG': {
            'HEADER': 'Forgot your password?',
            'BODY': 'Contact IT support for help',
            'OK_BTN_TEXT': 'OK',
        }
    }
};
